import React from 'react';

import logoSmall from '../../assets/images/logo_small.svg';
import logoAnimated from '../../assets/images/logo_animated.svg';
import classes from './Logo.css';

 const logo = (props) => {
     return (     
        <div className={classes.Logo} style={props.height? {height: props.height} : null}>
            <object className={classes.Image} type="image/svg+xml" data={props.animated? logoAnimated : logoSmall} aria-label='Logo'></object>
        </div>
     );
 } 

 export default logo;


// WEBPACK FOOTER //
// ./client/src/components/Logo/Logo.js